var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileParticipants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_430_13331)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 36,
    r: 27.5,
    fill: "#4D4D4E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1885 24.8091C31.5305 24.8091 29.3758 26.9638 29.3758 29.6218C29.3758 32.2798 31.5305 34.4345 34.1885 34.4345C36.8465 34.4345 39.0012 32.2798 39.0012 29.6218C39.0012 26.9638 36.8465 24.8091 34.1885 24.8091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0549 37.0013C26.3969 37.0013 24.2422 39.156 24.2422 41.814V43.3391C24.2422 44.3058 24.9428 45.13 25.8968 45.2858C31.3882 46.1823 36.9887 46.1823 42.4801 45.2858C43.4342 45.13 44.1348 44.3058 44.1348 43.3391V41.814C44.1348 39.156 41.98 37.0013 39.322 37.0013H38.8846C38.6478 37.0013 38.4125 37.0388 38.1874 37.1122L37.0766 37.475C35.2 38.0878 33.177 38.0878 31.3003 37.475L30.1895 37.1122C29.9644 37.0388 29.7292 37.0013 29.4924 37.0013H29.0549Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0973 28.0176C45.6289 28.0176 46.0599 28.4485 46.0599 28.9801V31.226H48.3058C48.8374 31.226 49.2683 31.657 49.2683 32.1886C49.2683 32.7202 48.8374 33.1511 48.3058 33.1511H46.0599V35.3971C46.0599 35.9287 45.6289 36.3596 45.0973 36.3596C44.5657 36.3596 44.1348 35.9287 44.1348 35.3971V33.1511H41.8888C41.3572 33.1511 40.9263 32.7202 40.9263 32.1886C40.9263 31.657 41.3572 31.226 41.8888 31.226H44.1348V28.9801C44.1348 28.4485 44.5657 28.0176 45.0973 28.0176Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_430_13331",
    x: 0.437323,
    y: 0.937323,
    width: 70.1254,
    height: 70.1254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.78134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_430_13331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_430_13331",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileParticipants);
export default __webpack_public_path__ + "static/media/mobile_participants.aceb76aba93d16175dcc5c112c86fa1d.svg";
export { ForwardRef as ReactComponent };